import { EditButton } from '@features/user-account/components/EditButton';
import { UserInfoList } from '@features/user-account/components/UserInfoList';
import { Paper, Box, Typography } from '@mui/material';
import RoundedBox from '@shared/components/RoundedBox';
import { FreemiumCategoryCardProps, FreemiumField } from '../types';

export const FreemiumCategoryCard: React.FC<FreemiumCategoryCardProps> = ({ title, fields, data, onEdit, showEditButton = true }) => {
  const list = (field: FreemiumField) => {
    const value = data?.[field.id];
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'number' || typeof value === 'string') return [String(value)];
    return [];
  };
  return (
    <Paper style={{ padding: 20 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="h4">{title}</Typography>
        {showEditButton && <EditButton onClick={onEdit} />}
      </Box>
      <RoundedBox>
        {fields.map((field, index) => (
          <UserInfoList list={list(field)} header={field.displayName} key={`${title}-${field.id}`} showDivider={index !== fields.length - 1} />
        ))}
      </RoundedBox>
    </Paper>
  );
};
